// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LS_KEY = "sepsis.auth.token";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(LS_KEY));
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  // Attach Authorization header globally whenever we have a token.
  useEffect(() => {
    if (token) axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    else delete axios.defaults.headers.common.Authorization;
  }, [token]);

  // On boot: validate the stored token against /api/auth/me.
  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!token) {
        setReady(true);
        return;
      }
      try {
        const r = await axios.get(`${API}/auth/me`);
        if (!cancelled) setUser(r.data);
      } catch (_e) {
        if (!cancelled) {
          localStorage.removeItem(LS_KEY);
          setToken(null);
          setUser(null);
        }
      } finally {
        if (!cancelled) setReady(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  const loginWithCode = useCallback(async (code) => {
    // @react-oauth/google popup flow uses the literal string "postmessage"
    // as redirect_uri during token exchange.
    const r = await axios.post(`${API}/auth/google`, { code, redirect_uri: "postmessage" });
    localStorage.setItem(LS_KEY, r.data.token);
    setToken(r.data.token);
    setUser({ email: r.data.email });
    return r.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(LS_KEY);
    setToken(null);
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ token, user, ready, loginWithCode, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
